<app-header [forceLightBackground]="true"></app-header>
<div class="consumer-my-request">
  <div class="flex min-h-screen w-full flex-col lg:flex-row">
    <div class="consumer-my-request--sidebar-col">
      <app-consumer-sidebar></app-consumer-sidebar>
    </div>
    <div class="consumer-my-request--content flex-1 min-w-0">
      <app-page-header></app-page-header>
      <app-my-request-shared></app-my-request-shared>
    </div>
  </div>
</div>
